module.exports = __webpack_public_path__ + "img/05.bc9486d3.png";